// extracted by mini-css-extract-plugin
module.exports = {"join":"_3pbXE9ZEbK9rQ0Culeg6Hw","forum":"qWoxud7mrPzGPmPJOd07E"};